import { BcOrderDto } from "../models/BcOrderDto";
import { CreateBcOrderDto } from "../models/CreateBcOrderDto";
import { Client, ClientProps } from "./Client";

export class FunctionClient extends Client {
  // TODO: Add msal token in requests
  constructor(props: ClientProps) {
    super(props);
  }

  async createOrders(data: CreateBcOrderDto[]) {
    return this.unwrap<BcOrderDto[]>(await this.post("", data));
  }

  async getOrders(params: URLSearchParams) {
    return this.unwrap<BcOrderDto[]>(await this.get("", params));
  }
}
